import {FunctionComponent} from 'react'

import { Card } from '@mui/material';

export interface LoadingProps {
  variant: string;
  height: string;
  toolbarLoading?: any;
}

export const Loading: FunctionComponent<LoadingProps> = ({variant, height, toolbarLoading}) => {
  return (
    <Card variant='outlined' style={{maxWidth:"md", height: height}}>
      {toolbarLoading?<>{toolbarLoading}</>:<div style={{position: "relative", top: "50%"}}>
        <span className={variant}></span>
      </div>}
    </Card>
  )
}